module.exports = __webpack_public_path__ + "img/product_banner.805fc79.jpg";